<template>
  <div class="foot_menus_container_lump" :class="returnShowMenuFlag()">
    <div v-for="(ele,index) in footMenus" :key="index" @click="goto(ele['value'])">

      <img v-if="ele['value']===curFooterMenu" :src="require('../../static/img/footer/'+ele['icon_active'])">
      <img v-else :src="require('../../static/img/footer/'+ele['icon'])">

      <span :class="ele['value']===curFooterMenu?'active':''">{{ ele['name'] }}</span>
    </div>
  </div>
</template>

<script>
import {getUserInfoStorage} from '../../util'
import Vue from 'vue';
import {Toast} from 'vant';
import {mapState} from "vuex";

Vue.use(Toast)
export default {
  name: "footMenus",
  data() {
    return {
      styleTypeFooter: 'origin',
      curFooterMenu: '',
      showMenuFlag: false,
    }
  },
  props: ['styleType'],
  watch: {
    '$route.name': {
      handler(newVal) {
        this.curFooterMenu = newVal
        let show = true
        // 下面路由隐藏底部菜单
        if (newVal === 'home' || newVal === 'promo' || newVal === 'service' || newVal === 'mine') {
          show = true
        } else {
          show = false
        }
        this.showMenuFlag = show
      },
      immediate: false
    },
    'styleType': {
      handler(newVal) {
        this.styleTypeFooter = newVal
        setTimeout(() => {
          this.pageShow = true
        }, 500)
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({
      sideContent: 'sideContent'
    }),
    footMenus() {
      return [
        {
          name: '首页',
          value: 'home',
          icon: 'tab_home_nor.png',
          icon_active: 'tab_home_select.png'
        },
        {
          name: '优惠',
          value: 'promo',
          icon: 'tab_promo_nor.png',
          icon_active: 'tab_promo_select.png'
        },
        {
          name: '客服',
          value: 'service',
          icon: 'tab_service_nor.png',
          icon_active: 'tab_service_select.png'
        },
        {
          name: '我的',
          value: 'mine',
          icon: 'tab_mine_nor.png',
          icon_active: 'tab_mine_select.png'
        },
      ]
    }
  },
  methods: {
    goto(address) {
      if (getUserInfoStorage() === null && address !== 'home' && address !== 'promo' && address !== 'service') {
        // 登录失效或未登录
        this.$message({message: '请先登录后再操作', type: 'warning'})
        this.$router.push({path: '/login'})
      } else {
        this.$router.push({name: address})
      }
    },
    returnShowMenuFlag() {
      if (this.showMenuFlag) {
        const curStyleType = 'foot_menus'
        return 'foot_menus_show ' + curStyleType
      } else {
        const curStyleType = 'foot_menus'
        return 'foot_menus_hide ' + curStyleType
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "footMenus.less";

.foot_menus_container_lump {
  //right: -80px;
}

@media screen and (max-width: 450px) {
  .foot_menus_container_lump {
    right: 0;
  }
}
</style>
